import React, { FormEvent, useContext } from 'react';
import cn from '@/utils/cn';
import I18n from '@/modules/i18n';
import { useModalManager } from '@/components/common/Modal';
import Tooltip from '@/components/common/Tooltip';
import SubmitModal from '@/components/ui/Modal/SubmitModal';
import DndAnswerContext from '@/components/common/Context';
import { Refresh } from '../../../../../../../../images/react';

interface ClearButtonProps {
  correctChoices: { [key: string]: string[] };
  currentChoices: { [key: string]: string[] };
  isComplete: boolean;
  savedChoices: { [key: string]: string[] };
}

const ClearButton = ({ correctChoices, currentChoices, isComplete, savedChoices }: ClearButtonProps) => {
  const { answerChoiceDispatch } = useContext(DndAnswerContext);
  const { close, isOpen, open } = useModalManager();

  const incorrectlyPlacedChoices = Object.entries(currentChoices).flatMap(([key, values]) => {
    const correctValues = correctChoices[key];
    const savedValues = savedChoices[key] || [];

    return values.map((value) => {
      const isSavedToDbAndCorrect = savedValues.includes(value) && correctValues?.includes(value);

      if (isSavedToDbAndCorrect) return undefined;

      return value;
    }).filter(value => !!value);
  });

  const isDisabled = incorrectlyPlacedChoices.length === 0 || isComplete;

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    incorrectlyPlacedChoices.forEach((draggableChoiceId) => {
      answerChoiceDispatch({ payload: { draggableChoiceId }, type: 'REMOVE' });
    });

    close();
  };

  return (
    <>
      <Tooltip content={isComplete ? I18n.t('clear_dropzones_disabled') : I18n.t('clear_dropzones')}>
        <div>
          <button
            aria-label={I18n.t('clear_dropzones')}
            className={cn(
              'tw-box-border tw-cursor-pointer tw-inline-flex tw-items-center tw-justify-center',
              'tw-border tw-border-solid tw-rounded-md tw-border-tci-purple',
              'tw-text-tci-purple hover:tw-text-white disabled:tw-text-very-dark-grey',
              'tw-bg-white hover:tw-bg-tci-purple disabled:tw-bg-light-grey',
              'tw-p-1 clear-button',
            )}
            disabled={isDisabled}
            type="button"
            onClick={open}
          >
            <Refresh aria-hidden className="tw-box-border tw-p-0.5 tw-text-inherit" fill="currentColor" />
          </button>
          <SubmitModal
            close={close}
            headerText={I18n.t('clear_dropzones')}
            isOpen={isOpen}
            onSubmit={handleSubmit}
          >
            <p className="tw-text-base">{I18n.t('clear_dropzones_message.line_1')}</p>
            <p className="tw-text-base">{I18n.t('clear_dropzones_message.line_2')}</p>
          </SubmitModal>
        </div>
      </Tooltip>
    </>
  );
};

export default ClearButton;
